import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { BasicBlockWrapper } from './BasicBlockWrapper';

/**
 * Basic renderer for an images block.
 */
export function BasicBlockImages(props: BlockProps): React.ReactElement {
    const { children } = props;

    return (
        <BasicBlockWrapper tag="div" style={{ width: '100%', height: '100%' }} {...props}>
            {children}
        </BasicBlockWrapper>
    );
}
